import BasisIcon from "@/assets/images/basis_icon.svg";
import BasisPragueLogo from "@/assets/images/basis_prague_logo.svg";

import { useAuth } from "@/lib/auth";
import { useBiometricScreenCaptureProtection } from "@/lib/auth/useBiometricScreenCaptureProtection";
import { THEME } from "@/lib/theme";
import { useColorScheme } from "nativewind";
import { Platform, View } from "react-native";

export function BiometricLockOverlay() {
    const {
        isBiometricLocked,
        isBiometricUnlockAvailable,
        isBiometricUnlockDisabled,
    } = useAuth();
    const { colorScheme } = useColorScheme();
    const scheme = colorScheme ?? "light";
    const isBiometricLockEnabled =
        isBiometricUnlockAvailable && !isBiometricUnlockDisabled;

    useBiometricScreenCaptureProtection(isBiometricLockEnabled);

    if (Platform.OS === "web" || !isBiometricLocked) {
        return null;
    }

    return (
        <View
            className="absolute inset-0 z-50 bg-primary"
            pointerEvents="auto"
            accessibilityElementsHidden
            importantForAccessibility="no-hide-descendants"
        >
            <View className="flex-1 items-center justify-center gap-4 px-6">
                <View className="flex-grow justify-center pt-[145px]">
                    <BasisIcon
                        style={{
                            width: 100,
                            height: 100,
                            color: THEME[scheme].primaryForeground,
                        }}
                        className="text-primaryForeground"
                    />
                </View>
                <View className="p-[50px]">
                    <BasisPragueLogo
                        style={{
                            width: 100,
                            height: 45,
                            color: THEME[scheme].primaryForeground,
                        }}
                        className="text-primaryForeground"
                    />
                </View>
            </View>
        </View>
    );
}
